import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Button } from '@/components/button'
import { Group } from '@/components/form'
import { createModal, useModalize } from '@/components/modalize/mui'
import { colors, fontSizes, fontWeights } from '@/styles'

const Header = styled.div`
  background-color: ${colors.white};
  height: 120px;
  position: sticky;
  top: 0;
`

const Title = styled.h4`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.medium};
  text-align: center;
  width: 100%;
  padding: 48px 0 20px;
`

const StyledGroup = styled(Group)`
  flex: 1;
  padding: 25px 30px;
  display: flex;
  justify-content: center;
`

const Disclaimer = styled.p`
  padding: 15px 30px;
  margin: 0;
  border-bottom: 1px solid ${colors.grey};
`

const GoToListingModal = ({ history, listingId }) => {
  const { close } = useModalize()
  const { t } = useTranslation()
  const goToListing = () => {
    close()
    history.push(`/listing/edit/${listingId}`)
  }
  return (
    <>
      <Header>
        <Title>{t('l.listing.create.existing.title', 'Listing already exists')}</Title>
      </Header>
      <Disclaimer>
        {t('l.listing.create.existing.description', 'It seems you have created this unit before.')}
      </Disclaimer>
      <StyledGroup>
        <Button theme="primary" onClick={goToListing}>
          {t('r.listing.create.go_to_listing.button', 'Go to Listing')}
        </Button>
      </StyledGroup>
    </>
  )
}

export const showExistingListingModal = createModal(GoToListingModal)
